var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgeGroup3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1650,
    height: 1283,
    viewBox: "0 0 1650 1283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8550_14723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 27,
    width: 1610,
    height: 1243
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1630 27H20V1270H1630V27Z",
    fill: "#EFE8CB"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8550_14723)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.78905 1233.44C-16.181 1217.74 -13.1917 1198.07 -1.43182 1184.9C10.3281 1171.72 30.2794 1165.76 47.7628 1170.15C47.6586 1143.72 63.6475 1117.7 87.932 1104.74C112.217 1091.79 143.8 1092.45 167.332 1106.4C191.072 1087.63 233.245 1099.59 242.051 1127.59C262.442 1112.36 297.595 1123.64 303.944 1147.45C322.679 1122.69 361.284 1113.87 389.565 1127.92C390.747 1102.22 411.869 1078.46 438.308 1073.03C464.759 1067.63 494.084 1081.1 505.971 1104.12C518.658 1087.11 553.115 1097.26 553.324 1118.07C567.76 1101.42 598.359 1101.26 612.795 1117.76C618.739 1097.42 636.315 1080.48 657.622 1074.56C678.929 1068.65 703.213 1073.98 719.538 1088.14C719.92 1064.49 741.969 1042.91 766.81 1041.9C791.65 1040.87 815.332 1060.56 817.591 1084.11C838.609 1074.9 866.566 1086.09 874.248 1106.76C893.678 1093.82 921.415 1093.51 941.03 1106C935.608 1087.62 947.206 1066.12 966.091 1059.51C984.965 1052.9 1008.31 1062.15 1016.55 1079.53C1033.51 1061.81 1066.39 1061.26 1083.81 1078.42C1088 1057.02 1106.5 1038.74 1128.81 1033.91C1151.12 1029.09 1175.96 1038.03 1186.33 1049.77C1215.1 1047.28 1239.4 1073.3 1244.09 1100.38C1248.78 1127.45 1239.18 1154.81 1229.71 1180.81C813.154 1175.77 396.123 1196.74 -8.78905 1233.43V1233.44Z",
    fill: "#1E916D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-226.235 1218.39C-126.409 1197.99 -61.9672 1138.27 147.51 1110.86C640.268 1046.36 1362.22 1043.34 1837 1145.4V1828.89C1837 1828.89 -438.609 1261.79 -226.235 1218.39Z",
    fill: "#6FDADD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402.67 1144.36C403.006 1154.59 394.988 1163.14 384.758 1163.48",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.701 1143.15C440.037 1153.37 432.02 1161.93 421.789 1162.27C411.57 1162.61 403.008 1154.59 402.672 1144.36",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M458.82 1161.07C448.59 1161.4 440.039 1153.38 439.703 1143.15",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M545.084 1106.22C545.42 1116.44 537.402 1125 527.172 1125.33",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M582.115 1105.01C582.451 1115.23 574.434 1123.79 564.203 1124.13C553.984 1124.46 545.422 1116.45 545.086 1106.22",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M601.234 1122.92C591.004 1123.26 582.453 1115.24 582.117 1105.01",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M714.068 1124.05C714.404 1134.27 706.387 1142.83 696.156 1143.17",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M751.084 1122.84C751.42 1133.07 743.402 1141.62 733.172 1141.96C722.941 1142.3 714.391 1134.28 714.055 1124.05",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M770.203 1140.76C759.984 1141.09 751.422 1133.07 751.086 1122.84",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M862.432 1105.14C862.768 1115.37 854.75 1123.92 844.52 1124.26",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M899.463 1103.93C899.799 1114.17 891.781 1122.72 881.551 1123.05C871.32 1123.39 862.77 1115.37 862.434 1105.14",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M918.582 1121.83C908.363 1122.17 899.801 1114.15 899.465 1103.92",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-982 1369.47C-982 1369.47 55.5842 1281.09 326.097 1247.14C828.506 1184.1 1325.01 1087.63 1647.94 1145.74L1638.38 1583.98L-916.527 1541.25L-982 1369.47Z",
    fill: "#54B08D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1586.16 661.089L1561.33 1144.87C1561.01 1151.25 1564.65 1157.23 1570.53 1159.7C1581.79 1164.41 1601.5 1169.5 1622.37 1160.22C1628.32 1157.57 1632.02 1151.49 1631.52 1145L1594.64 661.077H1586.16V661.089Z",
    fill: "#9C543F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.4 756.86C1504.93 737.14 1551.66 677.785 1583.66 601.386C1584.56 599.231 1587.56 599.092 1588.66 601.142C1601.06 624.141 1652.36 717.224 1687.45 749.364C1689.33 751.09 1688.13 754.218 1685.57 754.218H1672.5C1671.25 754.218 1670.16 755.041 1669.82 756.246L1667.62 763.974C1667.07 765.92 1664.68 766.65 1663.14 765.341L1659.86 762.572C1657.75 760.788 1654.6 762.815 1655.38 765.468C1659.85 780.727 1674.7 815.08 1722.61 851.02C1724.75 852.631 1723.62 856.049 1720.94 856.049H1712.53C1710.63 856.049 1709.27 857.914 1709.88 859.722L1713.56 870.775C1714.24 872.825 1712.44 874.841 1710.33 874.39L1694.36 870.949C1692.27 870.497 1690.47 872.455 1691.11 874.505C1696.1 890.436 1716.06 944.08 1764.45 966.87C1766.75 967.959 1766.54 971.284 1764.12 972.061L1756.05 974.633C1754.89 975.003 1754.1 976.081 1754.1 977.298V987.111C1754.1 989.359 1751.59 990.68 1749.73 989.417L1742.35 984.388C1740.44 983.091 1737.88 984.527 1738 986.833L1738.17 990.309C1738.29 992.649 1735.64 994.086 1733.74 992.707L1728.21 988.71C1726.65 987.586 1724.46 988.328 1723.91 990.147L1723.18 992.533C1722.63 994.318 1720.51 995.071 1718.96 994.04L1714.45 991.039C1712.77 989.926 1710.5 990.888 1710.16 992.881L1709.63 995.824C1709.23 998.095 1706.41 998.929 1704.85 997.249L1702.18 994.387C1700.58 992.684 1697.72 993.565 1697.39 995.882L1696.89 999.161C1696.54 1001.5 1693.61 1002.37 1692.05 1000.6L1687.3 995.256C1685.87 993.646 1683.24 994.19 1682.56 996.229L1680.98 1000.97C1680.34 1002.89 1677.93 1003.51 1676.45 1002.14L1674.25 1000.12C1672.66 998.674 1670.1 999.473 1669.64 1001.57L1668.87 1005.03C1668.39 1007.24 1665.62 1007.98 1664.09 1006.32L1662.47 1004.56C1661.09 1003.05 1658.62 1003.49 1657.83 1005.37L1657.15 1006.99C1656.45 1008.66 1654.38 1009.24 1652.92 1008.17L1647.49 1004.19C1646.03 1003.11 1643.94 1003.7 1643.26 1005.38L1641.22 1010.34C1640.41 1012.31 1637.78 1012.68 1636.44 1011.01L1633.17 1006.88C1631.79 1005.14 1629.03 1005.63 1628.32 1007.72L1627.41 1010.46C1626.75 1012.43 1624.26 1013.02 1622.78 1011.55L1619.49 1008.26C1617.87 1006.63 1615.08 1007.56 1614.75 1009.83L1614.69 1010.35C1614.4 1012.39 1612.08 1013.42 1610.38 1012.28L1605.32 1008.9C1604 1008.02 1602.2 1008.43 1601.38 1009.8L1599.31 1013.25C1598.08 1015.3 1595.02 1014.96 1594.27 1012.69C1593.54 1010.49 1590.59 1010.1 1589.3 1012.03L1587.31 1015.02C1586.21 1016.67 1583.81 1016.68 1582.68 1015.06L1578.72 1009.3C1577.74 1007.86 1575.69 1007.68 1574.45 1008.9L1569.07 1014.28C1567.4 1015.95 1564.55 1014.93 1564.32 1012.59L1564.07 1010.09C1563.82 1007.64 1560.75 1006.68 1559.16 1008.56L1554.32 1014.26C1552.84 1016 1550.01 1015.32 1549.48 1013.1L1548.09 1007.25C1547.6 1005.22 1545.16 1004.42 1543.57 1005.76L1534.97 1013.08C1533.56 1014.28 1531.38 1013.79 1530.62 1012.09L1526.96 1003.96C1526.19 1002.27 1524.02 1001.77 1522.61 1002.97L1518.72 1006.27C1517.26 1007.5 1515.03 1006.95 1514.33 1005.19L1511.01 996.901C1510.38 995.314 1508.48 994.665 1507 995.534L1500.81 999.184C1499.08 1000.2 1496.87 999.114 1496.62 997.121L1496.03 992.429C1495.83 990.807 1494.28 989.706 1492.68 990.042L1484.86 991.688C1483.12 992.058 1481.49 990.726 1481.49 988.953V987.54C1481.49 985.396 1479.16 984.052 1477.31 985.118L1466.31 991.456C1464.45 992.533 1462.13 991.189 1462.13 989.034V984.944C1462.13 982.361 1458.92 981.167 1457.23 983.114L1450.48 986.937C1448.33 988.154 1445.71 986.393 1446.04 983.948L1447.23 974.899C1447.23 973.416 1446.08 972.2 1444.6 972.107L1428.82 971.18C1426.32 971.029 1425.26 967.936 1427.14 966.291C1441.96 953.407 1483.67 915.578 1493.26 889.938C1494.03 887.887 1492.31 885.779 1490.16 886.173L1477.17 888.536C1475.14 888.907 1473.43 887.03 1473.98 885.049L1477.26 873.15C1477.76 871.331 1476.35 869.547 1474.46 869.616L1462.21 870.091C1459.48 870.195 1458.23 866.708 1460.43 865.063C1480.53 850.105 1533.7 806.993 1527.14 773.915C1526.83 772.362 1525.26 771.412 1523.72 771.794L1509.59 775.328C1507.98 775.734 1506.37 774.645 1506.15 772.988L1504.51 760.903C1504.28 759.212 1502.61 758.123 1500.98 758.598L1491.34 761.355C1488.69 762.108 1486.66 758.992 1488.43 756.883L1488.4 756.86Z",
    fill: "#035D55"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1571.55 664.264L1565.3 681.11",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1546.58 699.288L1540.34 716.134",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1573.56 695.372L1569.52 712.879",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.26 672.131L1584.91 690.089",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1608.66 679.001L1615.3 695.697",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1599.31 699.312L1605.72 716.1",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1629.71 699.892L1638.56 715.533",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.32 723.226L1546.08 740.083",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.8 740.083L1521.55 756.929",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.22 747.985L1560.5 765.874",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1582.49 724.581L1580.55 742.447",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1603.68 737.396L1610.08 754.184",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1623.42 721.754L1632.26 737.395",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1550.21 775.86L1543.96 792.707",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1577.2 771.944L1573.15 789.451",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1600.66 767.067L1604.36 784.655",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1555.94 799.811L1549.7 816.657",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1531.42 816.656L1525.18 833.502",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1565.85 824.558L1564.12 842.447",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1586.11 801.166L1584.18 819.02",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.26 816.274L1613.86 833.885",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1623.42 795.627L1632.26 811.268",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1548.98 845.344L1544.19 862.653",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1529.04 864.264L1522.8 881.11",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1504.29 849.967L1497.27 866.5",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1564.8 872.396L1560.39 889.822",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1586.11 841.032L1584.18 858.886",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1608.12 860.395L1612.09 877.913",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1540.95 891.618L1534.71 908.464",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1517.53 926.423L1508.79 942.122",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1581.17 889.614L1579.74 907.526",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1601.88 891.259L1605.6 908.835",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.1 916.922L1545.86 933.768",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1525.91 953.268L1519.68 970.114",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1511.26 899.404L1503.57 915.648",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1487.12 926.875L1476.95 941.682",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1564.64 940.002L1560.54 957.485",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.36 925.346L1585.42 943.211",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1611.5 940.454L1615.09 958.065",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.06 964.981L1591.88 982.952",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1627.18 918.846L1630.98 936.41",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1594.14 650.65L1595.98 668.516",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.13 626.446L1585.08 644.301",
    stroke: "#32766D",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M920.534 1166.14C916.455 1154.62 919.931 1141.04 929.096 1132.64C938.261 1124.24 952.662 1121.45 964.607 1125.75C966.392 1107.22 979.414 1090.11 997.338 1082.73C1015.26 1075.36 1037.36 1078.03 1052.86 1089.45C1070.81 1077.97 1099.53 1089.29 1103.73 1109.53C1119.09 1100.27 1142.93 1110.65 1145.71 1127.78C1160.58 1111.73 1188.24 1108.27 1207.08 1120.09C1209.71 1102.16 1226.18 1086.98 1245.08 1085.04C1263.99 1083.1 1283.61 1094.6 1290.33 1111.56C1300.41 1100.53 1323.85 1110.05 1322.54 1124.65C1333.82 1113.99 1355.27 1116.03 1364.24 1128.6C1369.83 1114.77 1383.33 1104.13 1398.67 1101.48C1414.01 1098.82 1430.66 1104.27 1441.11 1115.33C1443.03 1098.79 1460 1085.21 1477.48 1086.24C1494.96 1087.26 1510.17 1102.72 1510.11 1119.38C1525.48 1114.4 1544.3 1124.2 1548.22 1139.23C1562.74 1131.51 1582.21 1133.25 1595.08 1143.37C1592.56 1130.12 1602.2 1115.86 1615.9 1112.55C1629.59 1109.24 1645.3 1117.36 1649.86 1130.12C1662.98 1118.89 1686.08 1120.82 1697.07 1134.05C1701.51 1119.34 1715.75 1107.83 1731.72 1106.01C1747.7 1104.19 1764.48 1112.21 1770.93 1121.15C1791.27 1121.42 1806.47 1141.36 1807.87 1160.66C1809.26 1179.96 1800.62 1198.45 1792.16 1216.02C1500.59 1183.31 1206.87 1168.79 920.545 1166.15L920.534 1166.14Z",
    fill: "#035D55"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.59 797.734L1385.11 1226.84C1384.68 1232.5 1387.79 1237.89 1392.97 1240.21C1402.87 1244.63 1420.26 1249.58 1438.99 1241.78C1444.33 1239.56 1447.74 1234.24 1447.44 1228.46L1425.12 797.908L1417.57 797.723L1417.59 797.734Z",
    fill: "#834131"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.7 880.68C1343.81 863.521 1386.58 811.824 1416.65 744.659C1417.5 742.77 1420.16 742.712 1421.1 744.555C1431.62 765.247 1475.17 849.015 1505.63 878.316C1507.26 879.892 1506.13 882.638 1503.86 882.592C1499.77 882.487 1494.87 882.372 1492.25 882.314C1491.14 882.29 1490.15 882.997 1489.83 884.052L1487.7 890.864C1487.16 892.579 1485.03 893.17 1483.68 891.976L1480.83 889.439C1478.99 887.805 1476.14 889.543 1476.78 891.919C1480.42 905.567 1492.87 936.398 1534.64 969.337C1536.51 970.809 1535.43 973.821 1533.06 973.763L1525.58 973.578C1523.89 973.531 1522.65 975.165 1523.15 976.787L1526.18 986.682C1526.75 988.524 1525.1 990.273 1523.23 989.821L1509.12 986.415C1507.26 985.975 1505.63 987.678 1506.15 989.497C1510.24 1003.76 1526.81 1051.83 1569.3 1073.1C1571.31 1074.11 1571.07 1077.06 1568.89 1077.7L1561.66 1079.81C1560.63 1080.11 1559.9 1081.05 1559.88 1082.13L1559.67 1090.84C1559.62 1092.83 1557.36 1093.96 1555.74 1092.8L1549.29 1088.16C1547.62 1086.97 1545.31 1088.2 1545.36 1090.24L1545.44 1093.33C1545.5 1095.41 1543.11 1096.63 1541.47 1095.37L1536.64 1091.7C1535.28 1090.67 1533.32 1091.28 1532.78 1092.89L1532.07 1094.99C1531.55 1096.56 1529.65 1097.19 1528.29 1096.23L1524.35 1093.47C1522.89 1092.44 1520.86 1093.25 1520.5 1095.01L1519.97 1097.62C1519.57 1099.62 1517.04 1100.31 1515.69 1098.78L1513.38 1096.18C1512 1094.63 1509.44 1095.36 1509.08 1097.4L1508.57 1100.31C1508.21 1102.38 1505.6 1103.09 1504.24 1101.48L1500.14 1096.63C1498.91 1095.17 1496.56 1095.6 1495.91 1097.4L1494.4 1101.58C1493.79 1103.27 1491.65 1103.77 1490.35 1102.53L1488.44 1100.69C1487.06 1099.37 1484.76 1100.03 1484.31 1101.88L1483.56 1104.94C1483.07 1106.89 1480.61 1107.49 1479.28 1105.97L1477.88 1104.37C1476.69 1103.01 1474.49 1103.34 1473.75 1105L1473.11 1106.42C1472.46 1107.9 1470.59 1108.36 1469.33 1107.37L1464.59 1103.71C1463.32 1102.73 1461.45 1103.2 1460.8 1104.67L1458.88 1109.04C1458.12 1110.78 1455.76 1111.05 1454.63 1109.53L1451.81 1105.79C1450.63 1104.21 1448.16 1104.58 1447.5 1106.44L1446.63 1108.85C1446.01 1110.58 1443.77 1111.05 1442.51 1109.71L1439.66 1106.73C1438.25 1105.24 1435.76 1106.01 1435.42 1108.02L1435.34 1108.47C1435.04 1110.27 1432.96 1111.14 1431.47 1110.1L1427.05 1106.99C1425.9 1106.18 1424.3 1106.49 1423.53 1107.7L1421.62 1110.72C1420.48 1112.51 1417.77 1112.15 1417.16 1110.12C1416.56 1108.15 1413.95 1107.73 1412.76 1109.42L1410.91 1112.04C1409.91 1113.48 1407.76 1113.45 1406.81 1111.97L1403.42 1106.77C1402.57 1105.47 1400.75 1105.27 1399.63 1106.33L1394.74 1110.99C1393.22 1112.44 1390.72 1111.46 1390.56 1109.38L1390.38 1107.15C1390.22 1104.98 1387.52 1104.06 1386.06 1105.69L1381.64 1110.65C1380.28 1112.17 1377.78 1111.5 1377.36 1109.52L1376.25 1104.29C1375.87 1102.48 1373.7 1101.72 1372.26 1102.88L1364.47 1109.18C1363.18 1110.22 1361.26 1109.74 1360.62 1108.22L1357.55 1100.92C1356.91 1099.4 1354.99 1098.92 1353.7 1099.95L1350.17 1102.8C1348.85 1103.86 1346.88 1103.32 1346.29 1101.73L1343.52 1094.31C1342.99 1092.88 1341.32 1092.27 1339.98 1093.01L1334.4 1096.11C1332.85 1096.98 1330.9 1095.96 1330.73 1094.19L1330.31 1090.01C1330.16 1088.56 1328.82 1087.55 1327.39 1087.82L1320.42 1089.11C1318.86 1089.4 1317.45 1088.19 1317.48 1086.61L1317.52 1085.36C1317.57 1083.45 1315.53 1082.21 1313.86 1083.12L1303.95 1088.52C1302.27 1089.44 1300.24 1088.2 1300.29 1086.29L1300.38 1082.66C1300.44 1080.37 1297.61 1079.23 1296.07 1080.92L1289.99 1084.18C1288.06 1085.21 1285.77 1083.59 1286.11 1081.42L1287.36 1073.4C1287.39 1072.09 1286.4 1070.98 1285.09 1070.87L1271.09 1069.71C1268.88 1069.52 1268 1066.75 1269.71 1065.33C1283.14 1054.21 1321.01 1021.51 1330.08 998.94C1330.81 997.132 1329.32 995.232 1327.4 995.533L1315.82 997.352C1314.01 997.63 1312.53 995.939 1313.06 994.189L1316.22 983.692C1316.71 982.082 1315.49 980.471 1313.81 980.494L1302.93 980.657C1300.5 980.691 1299.47 977.563 1301.46 976.161C1319.63 963.312 1367.78 926.167 1362.67 896.657C1362.43 895.267 1361.06 894.398 1359.68 894.699L1347.05 897.538C1345.62 897.862 1344.2 896.854 1344.04 895.394L1342.85 884.619C1342.68 883.113 1341.22 882.117 1339.75 882.487L1331.13 884.724C1328.77 885.338 1327.03 882.522 1328.64 880.68H1328.7Z",
    fill: "#55B28F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.54 800.237L1398.63 815.068",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.61 830.802L1375.7 845.632",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.67 827.905L1401.7 843.361",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.54 807.514L1415.86 823.468",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.18 814.129L1442.72 829.098",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.44 831.961L1433.76 847.011",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1455.43 833.131L1462.95 847.208",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.19 852.19L1380.29 867.021",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.06 866.626L1358.15 881.456",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.46 874.389L1392.54 890.227",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.96 854.044L1410.86 869.871",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1431.5 865.873L1436.83 880.923",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1472.65 860.138L1480.9 873.809",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.37 852.41L1456.89 866.487",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.17 898.882L1377.28 913.712",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.24 895.985L1403.27 911.453",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.18 892.162L1431.1 907.861",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1457.13 895.696L1464.65 909.773",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.77 920.27L1381.86 935.1",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.62 934.706L1359.73 949.536",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.02 942.469L1394.1 958.319",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1414.53 922.123L1412.42 937.95",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1435.65 936.073L1438.47 951.784",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1454.51 956.024L1458.64 971.446",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1478.5 928.322L1486.75 941.994",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1487.43 957.751L1495.67 971.411",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.77 918.011L1455.3 932.099",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1380.59 960.566L1375.96 975.837",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.49 976.938L1356.58 991.756",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.82 963.707L1334.22 978.236",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.07 984.932L1389.77 1000.31",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1413.67 957.531L1411.56 973.358",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1432.79 975.2L1435.94 990.853",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1474.42 970.53L1482.67 984.202",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.47 1001.49L1366.56 1016.32",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.91 1031.89L1342.82 1045.64",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1408.23 1000.57L1406.58 1016.45",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1426.59 1002.47L1429.51 1018.16",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.86 991.281L1458.44 1006.57",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1475.94 1008.51L1481.78 1023.36",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.82 1024.2L1375.93 1039.03",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.79 1055.91L1351.88 1070.74",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1345.93 1007.76L1338.75 1022.02",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.91 1031.64L1314.55 1044.57",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.47 1044.96L1388.46 1060.4",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.96 1032.43L1410.85 1048.26",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1434.07 1046.38L1436.88 1062.1",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.28 1067.74L1415.72 1083.69",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.22 1037.95L1482.68 1052.94",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1501.62 1013.18L1509.87 1026.85",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1500.85 1045.02L1509.1 1058.69",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1448.45 1027.52L1451.45 1043.2",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1466.16 1058.23L1469.15 1073.9",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.9 788.628L1426.15 804.547",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1419.2 766.985L1417 782.8",
    stroke: "#76CEAB",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.45 940.64C1336.78 940.64 1335.42 939.284 1335.42 937.616V903.159C1335.42 901.49 1336.78 900.135 1338.45 900.135C1340.11 900.135 1341.47 901.49 1341.47 903.159V937.616C1341.47 939.284 1340.11 940.64 1338.45 940.64Z",
    fill: "#9C543F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.26 789.383C1166.26 789.383 1244.44 884.088 1339.53 915.892C1340.67 916.274 1341.62 917.039 1342.22 918.07C1354.32 939.11 1482.59 1161.31 1532.06 1202.87C1532.75 1203.45 1532.34 1204.56 1531.43 1204.56L1399 1203.82L1166.27 821.048V789.371L1166.26 789.383Z",
    fill: "#DEAC35"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1531.2 1210.11C1529.57 1209.75 1528.55 1208.13 1528.91 1206.49L1536.43 1172.87C1536.79 1171.24 1538.41 1170.22 1540.04 1170.58C1541.68 1170.94 1542.7 1172.56 1542.34 1174.19L1534.82 1207.82C1534.46 1209.45 1532.84 1210.47 1531.2 1210.11Z",
    fill: "#9C543F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.26 816.054C1164.59 816.054 1163.24 814.698 1163.24 813.03V778.573C1163.24 776.904 1164.59 775.549 1166.26 775.549C1167.93 775.549 1169.29 776.904 1169.29 778.573V813.03C1169.29 814.698 1167.93 816.054 1166.26 816.054Z",
    fill: "#9C543F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M922.016 1202.46C986.562 1135.35 1142.08 836.226 1163.75 794.284C1164.77 792.303 1167.62 792.361 1168.56 794.377C1215.77 895.906 1379.67 1167.55 1400 1201.17C1400.92 1202.67 1399.83 1204.6 1398.07 1204.6H922.931C921.819 1204.6 921.24 1203.27 922.016 1202.48V1202.46Z",
    fill: "#F4C74C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.33 1204.58L1167.42 901.259L1212.35 1204.58H1118.33Z",
    fill: "#C49020"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.42 901.259C1167.42 901.259 1242.77 1133.1 1298.55 1161C1298.55 1161 1250.98 1199.1 1212.34 1204.57L1167.42 901.247V901.259Z",
    fill: "#FFD77E"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.33 1204.58L1171.1 1195.19C1171.1 1195.19 1149 1093.74 1167.43 901.259L1118.33 1204.58V1204.58Z",
    fill: "#B27F12"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M923.105 1212.17C921.459 1212.48 919.884 1211.41 919.571 1209.76L913.187 1175.91C912.874 1174.26 913.951 1172.69 915.597 1172.37C917.242 1172.06 918.818 1173.14 919.131 1174.78L925.514 1208.64C925.827 1210.28 924.738 1211.86 923.105 1212.17Z",
    fill: "#9C543F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1397.38 1215.3C1395.75 1214.94 1394.73 1213.32 1395.09 1211.69L1402.61 1178.06C1402.97 1176.43 1404.59 1175.41 1406.22 1175.77C1407.86 1176.13 1408.88 1177.75 1408.52 1179.38L1401 1213.01C1400.64 1214.64 1399.02 1215.66 1397.38 1215.3Z",
    fill: "#9C543F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M919.177 1214.58L910.754 1196.94C910.418 1196.23 911.229 1195.52 911.89 1195.96L916.767 1199.25C917.219 1199.55 917.833 1199.31 917.949 1198.79L919.479 1192.29C919.641 1191.59 920.579 1191.48 920.915 1192.1L924.762 1199.21C925.005 1199.66 925.619 1199.75 925.99 1199.39L932.05 1193.44C932.583 1192.9 933.486 1193.38 933.359 1194.12L929.732 1214.4C929.663 1214.77 929.35 1215.03 928.968 1215.03H919.873C919.571 1215.03 919.305 1214.86 919.177 1214.59V1214.58Z",
    fill: "#2C8C6C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1395.66 1216.6L1386.88 1198.19C1386.62 1197.65 1387.24 1197.13 1387.72 1197.46L1393.43 1201.29C1393.77 1201.52 1394.23 1201.34 1394.33 1200.95L1396.04 1193.68C1396.17 1193.16 1396.86 1193.07 1397.12 1193.54L1401.34 1201.33C1401.52 1201.66 1401.97 1201.73 1402.25 1201.47L1408.94 1194.91C1409.34 1194.51 1410.01 1194.87 1409.91 1195.42L1406.14 1216.46C1406.1 1216.74 1405.85 1216.93 1405.58 1216.93H1396.19C1395.97 1216.93 1395.76 1216.81 1395.67 1216.61L1395.66 1216.6Z",
    fill: "#2C8C6C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1537.07 1212.04L1544.7 1196.06C1545.23 1194.96 1543.96 1193.85 1542.94 1194.54L1539.87 1196.6C1539.17 1197.06 1538.22 1196.69 1538.02 1195.88L1536.89 1191.09C1536.63 1190.01 1535.19 1189.82 1534.66 1190.78L1531.63 1196.39C1531.25 1197.1 1530.3 1197.24 1529.73 1196.68L1525.04 1192.07C1524.2 1191.25 1522.8 1191.99 1523.01 1193.14L1526.33 1211.73C1526.44 1212.31 1526.94 1212.73 1527.52 1212.73H1535.99C1536.45 1212.73 1536.87 1212.46 1537.07 1212.04V1212.04Z",
    fill: "#2C8C6C"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5996 1302.28C45.3778 1292.05 46.0035 1278.33 53.1058 1268.45C60.2197 1258.56 73.4626 1253 85.7786 1254.74C83.7858 1236.62 92.8462 1217.61 108.569 1206.95C124.291 1196.29 146.003 1194.44 163.151 1202.29C178.062 1187.69 207.873 1192.81 215.949 1211.37C228.821 1199.43 253.766 1204.62 259.86 1220.49C270.902 1202.14 296.75 1193.27 317.177 1200.84C316.111 1183.12 328.867 1165.28 346.617 1159.64C364.367 1154.01 385.465 1161.1 395.302 1176.02C402.764 1163.43 427.141 1167.88 428.798 1182.14C437.487 1169.66 458.47 1167.32 469.569 1177.59C472.164 1163.2 482.986 1150.3 497.167 1144.69C511.349 1139.09 528.404 1140.97 540.627 1149.49C539.167 1133.25 552.723 1116.83 569.685 1114.33C586.647 1111.81 604.339 1123.58 607.595 1139.57C621.347 1131.72 641.345 1137.36 648.111 1150.99C660.497 1140.69 679.498 1138.46 693.865 1145.6C688.813 1133.39 695.197 1117.79 707.664 1111.88C720.131 1105.97 736.826 1110.62 743.743 1121.94C754.09 1108.55 776.613 1105.78 789.798 1116.27C791.107 1101.28 802.473 1087.39 817.431 1082.45C832.389 1077.52 850.081 1081.85 858.052 1089.14C877.598 1085.33 896.17 1101.41 901.361 1119.64C906.552 1137.87 901.963 1157.35 897.364 1175.87C611.233 1202.79 326.677 1247.58 51.5764 1302.28H51.5996Z",
    fill: "#035D55"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M442.521 1167.58C443.815 1167.52 444.811 1166.43 444.758 1165.13L443.539 1138.47C443.476 1137.18 442.384 1136.18 441.09 1136.24C439.797 1136.3 438.801 1137.39 438.854 1138.68L440.073 1165.35C440.136 1166.64 441.228 1167.64 442.521 1167.58Z",
    fill: "#9C543F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M570.361 1044.44C570.361 1044.44 513.232 1120.48 440.806 1148.47C439.937 1148.81 439.227 1149.43 438.803 1150.25C430.195 1166.96 338.836 1343.42 302.04 1377.33C301.531 1377.81 301.891 1378.65 302.591 1378.62L405.028 1373.35L571.495 1068.94L570.371 1044.43L570.361 1044.44Z",
    fill: "#DEAC35"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M571.311 1065.08C572.604 1065.02 573.6 1063.93 573.547 1062.63L572.328 1035.97C572.265 1034.68 571.173 1033.68 569.879 1033.74C568.586 1033.8 567.59 1034.89 567.643 1036.18L568.862 1062.85C568.925 1064.14 570.017 1065.14 571.311 1065.08Z",
    fill: "#9C543F"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M774.002 1355.36C721.676 1305.72 590.732 1079.83 572.488 1048.14C571.63 1046.65 569.425 1046.79 568.767 1048.39C535.841 1128.61 418.689 1344.6 404.156 1371.32C403.498 1372.52 404.41 1373.97 405.778 1373.91L773.376 1357.03C774.235 1356.99 774.638 1355.95 774.013 1355.36H774.002Z",
    fill: "#F4C74C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M622.197 1363.97L573.433 1131.04L549.453 1367.3L622.197 1363.97Z",
    fill: "#C49020"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M421.511 1133.25L451.112 1709.94C451.503 1717.55 447.161 1724.68 440.133 1727.62C426.704 1733.24 403.214 1739.31 378.347 1728.24C371.252 1725.08 366.843 1717.84 367.436 1710.1L411.394 1133.25H421.511V1133.25Z",
    fill: "#9C543F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M538.057 1247.41C518.35 1223.9 462.652 1153.14 424.49 1062.07C423.416 1059.51 419.835 1059.34 418.514 1061.79C403.731 1089.21 342.583 1200.17 300.751 1238.48C298.501 1240.53 299.934 1244.26 302.978 1244.26C308.472 1244.26 315.042 1244.26 318.556 1244.26C320.044 1244.26 321.342 1245.25 321.745 1246.68L324.375 1255.89C325.035 1258.22 327.878 1259.08 329.724 1257.51L333.63 1254.21C336.137 1252.08 339.908 1254.5 338.979 1257.67C333.652 1275.86 315.937 1316.81 258.829 1359.65C256.266 1361.57 257.62 1365.64 260.821 1365.64H270.848C273.12 1365.64 274.72 1367.87 274.004 1370.02L269.617 1383.19C268.8 1385.64 270.96 1388.03 273.478 1387.5L292.514 1383.39C295.01 1382.85 297.158 1385.19 296.397 1387.63C290.444 1406.62 266.651 1470.58 208.973 1497.74C206.231 1499.03 206.466 1503 209.364 1503.92L218.989 1506.98C220.365 1507.42 221.305 1508.71 221.305 1510.15V1521.84C221.305 1524.52 224.304 1526.1 226.509 1524.6L235.305 1518.6C237.577 1517.05 240.643 1518.77 240.509 1521.52L240.297 1525.67C240.162 1528.46 243.307 1530.17 245.567 1528.54L252.17 1523.77C254.017 1522.44 256.624 1523.31 257.296 1525.49L258.169 1528.34C258.829 1530.46 261.347 1531.36 263.193 1530.13L268.565 1526.54C270.568 1525.21 273.277 1526.37 273.691 1528.74L274.306 1532.25C274.787 1534.96 278.145 1535.96 280.014 1533.94L283.192 1530.54C285.094 1528.5 288.508 1529.57 288.91 1532.32L289.492 1536.24C289.906 1539.02 293.398 1540.06 295.267 1537.96L300.93 1531.59C302.631 1529.68 305.764 1530.33 306.57 1532.76L308.45 1538.41C309.211 1540.69 312.076 1541.44 313.855 1539.81L316.485 1537.4C318.377 1535.67 321.432 1536.63 321.98 1539.13L322.898 1543.25C323.48 1545.88 326.781 1546.77 328.605 1544.77L330.541 1542.67C332.186 1540.88 335.13 1541.4 336.07 1543.64L336.875 1545.58C337.703 1547.57 340.177 1548.26 341.911 1546.98L348.391 1542.22C350.137 1540.95 352.61 1541.64 353.438 1543.64L355.878 1549.56C356.851 1551.91 359.985 1552.36 361.563 1550.36L365.469 1545.42C367.114 1543.35 370.404 1543.92 371.232 1546.44L372.317 1549.7C373.101 1552.05 376.078 1552.75 377.823 1551L381.74 1547.08C383.676 1545.14 387 1546.25 387.392 1548.96L387.481 1549.58C387.828 1552 390.581 1553.24 392.618 1551.87L398.639 1547.85C400.217 1546.8 402.365 1547.28 403.339 1548.9L405.812 1553.02C407.278 1555.46 410.927 1555.06 411.822 1552.36C412.695 1549.73 416.209 1549.26 417.753 1551.57L420.137 1555.14C421.446 1557.1 424.311 1557.12 425.654 1555.17L430.366 1548.31C431.541 1546.6 433.991 1546.38 435.457 1547.84L441.87 1554.25C443.851 1556.23 447.253 1555.03 447.533 1552.23L447.835 1549.24C448.126 1546.32 451.785 1545.18 453.688 1547.42L459.462 1554.21C461.231 1556.29 464.61 1555.47 465.237 1552.82L466.904 1545.84C467.475 1543.42 470.407 1542.47 472.298 1544.07L482.549 1552.79C484.239 1554.22 486.836 1553.64 487.742 1551.61L492.107 1541.92C493.013 1539.91 495.598 1539.31 497.288 1540.75L501.932 1544.67C503.667 1546.14 506.331 1545.48 507.17 1543.36L511.12 1533.48C511.881 1531.59 514.142 1530.82 515.899 1531.85L523.296 1536.2C525.355 1537.41 527.985 1536.12 528.287 1533.75L528.992 1528.16C529.239 1526.22 531.074 1524.91 532.976 1525.31L542.299 1527.27C544.369 1527.71 546.316 1526.13 546.316 1524.02V1522.34C546.316 1519.77 549.092 1518.17 551.307 1519.45L564.412 1527.01C566.628 1528.29 569.403 1526.69 569.403 1524.13V1519.25C569.403 1516.17 573.219 1514.74 575.245 1517.07L583.291 1521.63C585.854 1523.09 588.965 1520.98 588.585 1518.06L587.164 1507.27C587.164 1505.52 588.54 1504.05 590.297 1503.95L609.109 1502.84C612.086 1502.66 613.351 1498.97 611.101 1497.01C593.442 1481.66 543.709 1436.56 532.283 1405.98C531.365 1403.54 533.413 1401.03 535.976 1401.5L551.464 1404.32C553.881 1404.75 555.918 1402.53 555.269 1400.16L551.363 1385.97C550.77 1383.8 552.449 1381.68 554.698 1381.77L569.291 1382.34C572.559 1382.46 574.037 1378.3 571.418 1376.35C547.458 1358.52 484.071 1307.12 491.883 1267.7C492.252 1265.84 494.121 1264.72 495.956 1265.18L512.799 1269.39C514.724 1269.87 516.637 1268.57 516.906 1266.6L518.853 1252.18C519.122 1250.17 521.114 1248.87 523.061 1249.43L534.554 1252.71C537.71 1253.62 540.127 1249.89 538.024 1247.37L538.057 1247.41Z",
    fill: "#0C3325"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M438.938 1137.03L446.368 1157.12",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M468.695 1178.77L476.137 1198.86",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M436.52 1174.1L441.343 1194.97",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M422.59 1146.41L423.004 1167.81",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M394.701 1154.6L386.789 1174.5",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M405.843 1178.82L398.199 1198.83",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M369.597 1179.5L359.055 1198.14",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M461.855 1207.32L469.298 1227.41",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M491.09 1227.41L498.521 1247.5",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M450.051 1236.83L452.11 1258.15",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M425.891 1208.94L428.196 1230.23",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M400.632 1224.21L393 1244.21",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M345.625 1215.18L334.109 1233.24",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M377.108 1205.56L366.555 1224.21",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M464.375 1270.06L471.817 1290.14",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M432.203 1265.39L437.026 1286.26",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M404.233 1259.58L399.812 1280.54",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M365.28 1263.39L354.738 1282.02",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M412.002 1120.8L409.809 1142.11",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M420.363 1091.95L422.803 1113.22",
    stroke: "#1F4736",
    strokeWidth: 2.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M178.48 733.468L227.531 1689.22C228.18 1701.83 220.995 1713.65 209.345 1718.53C187.086 1727.84 148.152 1737.9 106.947 1719.55C95.185 1714.31 87.8772 1702.31 88.862 1689.48L161.716 733.468H178.48Z",
    fill: "#834131"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M371.614 922.664C338.959 883.708 246.644 766.448 183.414 615.514C181.635 611.261 175.704 610.981 173.521 615.044C149.024 660.491 47.6778 844.371 -21.6397 907.858C-25.3663 911.271 -22.9826 917.449 -17.9355 917.449C-8.83713 917.449 2.06298 917.449 7.88233 917.449C10.3444 917.449 12.493 919.083 13.1757 921.444L17.5402 936.709C18.637 940.558 23.3484 941.991 26.4035 939.406L32.872 933.933C37.0351 930.408 43.2685 934.426 41.7353 939.663C32.9056 969.812 3.56259 1037.67 -91.0915 1108.67C-95.3329 1111.85 -93.0946 1118.6 -87.7901 1118.6H-71.1714C-67.4112 1118.6 -64.7477 1122.29 -65.934 1125.86L-73.2082 1147.69C-74.5623 1151.74 -70.9923 1155.73 -66.818 1154.83L-35.2704 1148.03C-31.1409 1147.13 -27.571 1151.02 -28.8356 1155.05C-38.6949 1186.53 -78.1322 1292.51 -173.726 1337.53C-178.27 1339.67 -177.867 1346.25 -173.088 1347.77L-157.141 1352.85C-154.858 1353.58 -153.303 1355.7 -153.303 1358.11V1377.49C-153.303 1381.92 -148.345 1384.54 -144.685 1382.05L-130.103 1372.1C-126.343 1369.53 -121.263 1372.38 -121.486 1376.93L-121.833 1383.81C-122.068 1388.44 -116.842 1391.27 -113.093 1388.56L-102.148 1380.66C-99.0819 1378.44 -94.7621 1379.9 -93.643 1383.51L-92.1994 1388.22C-91.1138 1391.75 -86.9396 1393.24 -83.8732 1391.19L-74.9763 1385.26C-71.6637 1383.05 -67.1762 1384.97 -66.4823 1388.88L-65.4527 1394.7C-64.6582 1399.18 -59.0962 1400.84 -55.9851 1397.51L-50.7141 1391.87C-47.5694 1388.5 -41.9067 1390.25 -41.2241 1394.81L-40.2504 1401.31C-39.5566 1405.93 -33.782 1407.65 -30.6709 1404.15L-21.2928 1393.59C-18.4726 1390.43 -13.28 1391.49 -11.9371 1395.52L-8.81472 1404.89C-7.55013 1408.68 -2.8051 1409.91 0.149337 1407.2L4.50261 1403.22C7.63611 1400.35 12.6945 1401.94 13.6122 1406.08L15.1341 1412.92C16.0966 1417.28 21.569 1418.74 24.5794 1415.45L27.7801 1411.96C30.4995 1408.99 35.39 1409.84 36.9344 1413.56L38.2772 1416.77C39.6537 1420.07 43.7497 1421.21 46.6258 1419.1L57.3692 1411.22C60.2565 1409.11 64.3636 1410.26 65.729 1413.57L69.7689 1423.37C71.3692 1427.27 76.5731 1428 79.1918 1424.69L85.6602 1416.53C88.3797 1413.09 93.8297 1414.04 95.2174 1418.2L97.0192 1423.61C98.3174 1427.5 103.253 1428.67 106.151 1425.77L112.642 1419.28C115.854 1416.07 121.36 1417.9 121.998 1422.4L122.143 1423.42C122.714 1427.44 127.291 1429.47 130.66 1427.22L140.642 1420.57C143.261 1418.82 146.808 1419.61 148.431 1422.32L152.527 1429.16C154.955 1433.2 160.999 1432.54 162.487 1428.06C163.942 1423.71 169.761 1422.93 172.313 1426.74L176.252 1432.66C178.412 1435.91 183.179 1435.94 185.384 1432.73L193.195 1421.36C195.154 1418.52 199.205 1418.15 201.644 1420.59L212.276 1431.22C215.566 1434.51 221.195 1432.5 221.665 1427.87L222.158 1422.93C222.639 1418.09 228.693 1416.2 231.849 1419.91L241.418 1431.16C244.338 1434.61 249.945 1433.27 250.986 1428.87L253.739 1417.3C254.69 1413.29 259.536 1411.7 262.681 1414.38L279.669 1428.81C282.466 1431.2 286.764 1430.22 288.275 1426.88L295.504 1410.81C297.004 1407.46 301.301 1406.49 304.099 1408.86L311.798 1415.37C314.674 1417.8 319.083 1416.7 320.482 1413.21L327.029 1396.84C328.283 1393.71 332.032 1392.42 334.952 1394.13L347.207 1401.34C350.62 1403.35 354.984 1401.2 355.477 1397.27L356.641 1387.99C357.044 1384.79 360.088 1382.61 363.255 1383.28L378.698 1386.53C382.123 1387.25 385.346 1384.64 385.346 1381.14V1378.35C385.346 1374.11 389.945 1371.46 393.616 1373.57L415.338 1386.11C419.02 1388.23 423.608 1385.57 423.608 1381.33V1373.25C423.608 1368.15 429.942 1365.79 433.288 1369.63L446.617 1377.2C450.858 1379.61 456.029 1376.13 455.391 1371.29L453.041 1353.41C453.041 1350.49 455.312 1348.07 458.233 1347.9L489.412 1346.07C494.347 1345.78 496.451 1339.65 492.724 1336.41C463.459 1310.96 381.048 1236.21 362.091 1185.55C360.58 1181.5 363.971 1177.34 368.212 1178.11L393.873 1182.78C397.869 1183.51 401.26 1179.8 400.174 1175.88L393.706 1152.36C392.721 1148.76 395.507 1145.24 399.245 1145.39L423.429 1146.34C428.845 1146.55 431.296 1139.65 426.954 1136.41C387.248 1106.86 282.198 1021.68 295.146 956.349C295.75 953.271 298.85 951.402 301.883 952.163L329.805 959.147C332.994 959.941 336.172 957.793 336.609 954.536L339.832 930.654C340.279 927.319 343.581 925.171 346.815 926.088L365.851 931.527C371.077 933.027 375.095 926.849 371.592 922.686L371.614 922.664Z",
    fill: "#035D55"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M207.344 739.734L219.676 773.028",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M256.676 808.93L269.008 842.212",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M203.355 801.185L211.335 835.776",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M180.262 755.279L180.944 790.766",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M134.027 768.854L120.922 801.834",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M152.505 808.986L139.848 842.145",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4414 810.127L74.9609 841.014",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M245.332 856.233L257.664 889.516",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M293.77 889.516L306.102 922.798",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M225.773 905.14L229.187 940.47",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M185.73 858.908L189.558 894.194",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M143.868 884.211L131.211 917.381",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7024 869.25L33.6328 899.186",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M104.875 853.323L87.3945 884.211",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M249.52 960.21L261.841 993.492",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M196.195 952.465L204.186 987.056",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M149.853 942.842L142.512 977.568",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2885 949.141L67.7969 980.028",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M238.172 1007.51L250.504 1040.8",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M286.617 1040.8L298.939 1074.08",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M218.605 1056.42L222.019 1091.75",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M178.566 1010.19L182.394 1045.49",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M130.86 1040.05L123.754 1074.83",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8418 1083.4L77.8594 1117.45",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0071 1020.53L16.9375 1050.47",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M104.875 999.256L87.3945 1030.15",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M251.938 1097.48L261.416 1131.68",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M291.328 1134.85L303.661 1168.13",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M340.211 1106.6L354.088 1139.27",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M220.68 1150.93L229.397 1185.34",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M178.566 1088.95L182.394 1124.24",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M135.106 1127.2L127.25 1161.83",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M42.819 1114.58L23.7383 1144.51",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M267.793 1188.9L280.126 1222.18",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M314.078 1257.66L331.335 1288.68",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M188.348 1184.94L191.157 1220.32",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M147.412 1188.17L140.07 1222.91",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3915 1161.83L76.3906 1195.57",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M37.389 1198.93L23.6016 1231.64",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M245.77 1238.88L258.091 1272.17",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M326.457 1204.28L341.632 1236.37",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M374.133 1258.54L394.232 1287.79",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M176.129 1255.52L179.956 1290.82",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9408 1264.3L20.0039 1297.35",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4433 1242.69L89.9453 1277.39",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M162.708 712.843L159.082 748.151",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M176.555 665.034L180.606 700.297",
    stroke: "#28736A",
    strokeWidth: 4.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1785.59 230.599H1396.2C1392.01 205.521 1406.69 195.135 1418.85 194.278C1431 193.411 1444.33 196.42 1454.6 189.879C1469.29 180.517 1467.77 159.033 1473.99 142.764C1479.91 127.268 1494.59 115.482 1511 113.047C1527.4 110.612 1544.87 117.634 1555.04 130.737C1568.4 147.957 1571.12 175.376 1591.4 183.348C1613.52 192.042 1639.44 169.545 1661.11 179.305C1673.75 184.999 1680.27 200.056 1693.05 205.448C1703.34 209.795 1715.18 206.806 1725.65 202.909C1736.12 199.011 1746.77 194.163 1757.92 194.926C1769.07 195.689 1786.74 205.866 1785.59 230.62V230.599Z",
    fill: "#EFE8CB",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M470.044 82.5021H168.055C164.398 72.0531 175.505 59.859 186.236 57.1109C196.968 54.3628 208.984 54.9271 218.064 48.5845C236.904 35.4186 231.523 1.36507 251.669 -9.7005C263.236 -16.0431 278.126 -11.0484 288.136 -2.4593C298.146 6.12985 304.98 17.7806 313.799 27.5923C322.618 37.4039 334.916 45.7841 348.02 44.2795C360.214 42.8793 370.819 33.1616 383.066 33.9975C397.945 35.0111 407.705 50.8728 422.114 54.7494C431.309 57.2154 441.194 54.4568 450.546 56.2436C459.898 58.0304 475.592 74.7907 470.033 82.5126L470.044 82.5021Z",
    fill: "#EFE8CB",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M730.111 572.919H457.505C454.579 555.364 464.851 548.092 473.356 547.486C481.862 546.88 491.193 548.98 498.392 544.403C508.674 537.852 507.608 522.805 511.966 511.416C516.114 500.569 526.396 492.315 537.879 490.611C549.363 488.908 561.599 493.819 568.715 502.994C578.067 515.052 579.968 534.236 594.169 539.827C609.654 545.918 627.794 530.161 642.976 536.995C651.827 540.976 656.393 551.519 665.337 555.291C672.547 558.332 680.833 556.242 688.158 553.515C695.493 550.788 702.944 547.392 710.749 547.925C718.554 548.458 730.926 555.584 730.122 572.908L730.111 572.919Z",
    fill: "#EFE8CB",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.59 46.4616H988.222C985.234 37.9352 994.304 27.9877 1003.05 25.7516C1011.81 23.505 1021.61 23.9648 1029.02 18.7925C1044.39 8.05082 1040 -19.7332 1056.43 -28.7613C1065.87 -33.944 1078.01 -29.8584 1086.18 -22.8575C1094.35 -15.8462 1099.92 -6.348 1107.12 1.65599C1114.32 9.65999 1124.35 16.4937 1135.04 15.2711C1144.99 14.1322 1153.64 6.20134 1163.64 6.88053C1175.78 7.70601 1183.75 20.6524 1195.5 23.808C1203 25.8247 1211.07 23.5677 1218.7 25.0306C1226.33 26.4934 1239.14 40.1608 1234.59 46.4616V46.4616Z",
    fill: "#EFE8CB",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.27 641.276H1130.66C1127.74 623.722 1138.01 616.449 1146.51 615.843C1155.02 615.237 1164.35 617.337 1171.55 612.761C1181.83 606.209 1180.76 591.162 1185.12 579.773C1189.27 568.927 1199.55 560.672 1211.04 558.969C1222.52 557.266 1234.76 562.177 1241.87 571.351C1251.22 583.409 1253.12 602.594 1267.32 608.184C1282.81 614.276 1300.95 598.519 1316.13 605.352C1324.98 609.333 1329.55 619.876 1338.49 623.649C1345.7 626.689 1353.99 624.6 1361.31 621.872C1368.65 619.145 1376.1 615.749 1383.91 616.282C1391.71 616.815 1404.08 623.941 1403.28 641.266L1403.27 641.276Z",
    fill: "#EFE8CB",
    fillOpacity: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeGroup3);
export default __webpack_public_path__ + "static/media/AgeGroup3.573a234ca06bb0945682b4fa24b08adf.svg";
export { ForwardRef as ReactComponent };